import StudyTemplate from "./portfolio/templates/study/StudyTemplate";
import GalTemplate from "./portfolio/templates/gallery/GalTemplate";
import GenTemplate from "./portfolio/templates/generative/GenTemplate";
import ShowTemplate from "./portfolio/templates/showcase/ShowTemplate";
import React from "react";
import { useParams } from "react-router-dom";
import { createSlug } from "./createSlug";
import labels from "./labels.json";
import "./style.css";

const PortfolioItem = () => {
  const { slug } = useParams();
  const matchedItem = labels.find(
    (currentItem) => createSlug(currentItem.title) === slug
  );
  const id = labels.indexOf(matchedItem) + 1;
  const item = matchedItem;

  if (!item) {
    return <div>Item not found</div>;
  }

  let renderedTemplate;
  switch (item.template) {
    case "study":
      renderedTemplate = <StudyTemplate />;
      break;
    case "gallery":
      renderedTemplate = <GalTemplate />;
      break;
    case "generative":
      renderedTemplate = <GenTemplate />;
      break;
    case "showcase":
      renderedTemplate = <ShowTemplate />;
      break;
    default:
      // Fallback for any other template type
      renderedTemplate = (
        <section className="portfolio-item-section">
          <div className="portfolio-item-content">
            <h2 className="portfolio-item-title">
              {item.title} - {item.subtitle}
            </h2>
            <img
              className="portfolio-item-image"
              src={`./assets/images/project-${id}.png`}
              alt={item.title}
            />
            <p className="portfolio-item-description">{item.description}</p>
            <div className="portfolio-item-gallery">
              <img src="/path/to/placeholder1.jpg" alt="Gallery Image 1" />
              <img src="/path/to/placeholder2.jpg" alt="Gallery Image 2" />
              <img src="/path/to/placeholder3.jpg" alt="Gallery Image 3" />
            </div>
          </div>
        </section>
      );
  }

  return <>{renderedTemplate}</>;
};

export default PortfolioItem;
